(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

//header-search表示非表示
jQuery(function ($) {
  const $headerSearch = $('.header-search');
  const threshold = 30;
  function toggleHeaderSearch() {
    const scrollY = $(window).scrollTop();
    const viewportWidth = $(window).width();
    if (viewportWidth <= 989) {
      if (scrollY <= threshold) {
        if (!$headerSearch.is(':visible')) {
          $headerSearch.stop(true, true).fadeIn(300);
        }
      } else {
        if ($headerSearch.is(':visible')) {
          $headerSearch.stop(true, true).fadeOut(300);
        }
      }
    } else {
      // PC幅の場合は常に表示に戻す（fadeでなく一気に）
      $headerSearch.stop(true, true).css('display', '');
    }
  }
  toggleHeaderSearch();
  $(window).on('scroll resize', function () {
    toggleHeaderSearch();
  });
});

//pc用drawer
jQuery(function ($) {
  const $open = $('.header-pc-burger__open');
  const $close = $('.header-pc-burger__close');
  const $sub = $('.site-header__element--sub');

  const threshold = 30;
  let manualMode = false; // ←クリック操作中は true にする

  // 初期非表示
  $open.hide();
  $close.hide();

  // スクロール処理
  function toggleHeaderByScroll() {
    if (manualMode) return;

    const scrollY = $(window).scrollTop();
    const vw = $(window).width();

    if (vw >= 1120) {
      if (scrollY <= threshold) {
        $open.stop(true, false).fadeOut(150);
        $close.stop(true, false).fadeOut(0);
        $sub.slideDown(100);
      } else {
        if (!$open.is(':visible')) {
          $open.stop(true, false).fadeIn(200);
        }
        $close.hide();
        $sub.slideUp(100);
      }
    } else {
      // PC幅でない場合は全部リセット
      $open.hide();
      $close.hide();
      $sub.show();
    }
  }

  // 初期実行
  toggleHeaderByScroll();
  $(window).on('scroll resize', toggleHeaderByScroll);

  // openクリック
  $open.on('click', function () {
    manualMode = true; // ←クリック開始
    $open.stop(true, false).fadeOut(0);
    $close.stop(true, false).fadeIn(150);
    $sub.stop(true, false).slideDown(150);
  });

  // closeクリック
  $close.on('click', function () {
    manualMode = true; // ←クリック開始
    $sub.stop(true, false).slideUp(200, function () {
      $close.stop(true, false).fadeOut(0);
      $open.stop(true, false).fadeIn(150);
    });
  });

  $(document).on('click', function () {
    setTimeout(() => {
      manualMode = false;
    }, 400);
  });
});



  } catch(e) { console.error(e); }
})();
})();
